export default __webpack_public_path__ + "static/media/new-image.45ab8b0e.svg";